import React, { useState, useEffect, useRef } from "react";
import "./RespondentFilter.scss";
import {
  Button,
  Drawer,
  Row,
  Col,
  Divider,
  Select,
  Input,
  Space,
  Modal,
  Tooltip,
  Checkbox,
  Form,
  InputNumber,
  Radio,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  CloseOutlined,
  RightOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import DeleteIcon from "../../assets/icons/delete.svg";
import PlusIcon from "../../assets/icons/plus-icon.svg";
import { TreeSelect } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setExploreFilterApplyData, setTargetPopulationFilterData,setshowWarningMsg } from "../../reducer/PEBCommonSlice";
import {
  getExploreFilterDropdownDataAPI,
  saveExploreFilterAPI,
} from "../../services/ExploreAPI";
import { LeftOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import InfoIcon from "../../assets/icons/info.svg";
import { MAX_ALLOWED_CARDS } from "../../constants/ResponseDetailConstant";
import { useRefreshActions } from "../../shared/refreshReportFunctions/useRefreshFunctions";
// import {INDICATION_TREE_STRUCTURE} from "../../constants/IndicationTreeStructure"

const { SHOW_ALL, SHOW_PARENT } = TreeSelect;

const getParentTitle = (key, tree) => {
  let parentTitle;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentTitle = node.title;
      } else if (getParentTitle(key, node.children)) {
        parentTitle = getParentTitle(key, node.children);
      }
    }
  }
  return parentTitle;
};

const RespondentFilter = (props) => {
  const {refreshScreen} = props;
  const maxReportCards = useSelector((state) => state.PEBCommon?.refreshReport?.maxReportCards);
  const disableReportIndex = useSelector((state)=>state.PEBCommon?.refreshReport.disableReportIndex);
  const filterExportLibraryCurrentPageData = useSelector((state)=>state.PEBCommon?.refreshReport.filterExportLibraryCurrentPageData);
  const exploreFilterApplyData =  useSelector((state)=>state.PEBCommon?.exploreFilterApplyData);
  const minimizedOpenedReport = useSelector(
    (state) => state.PEBCommon?.minimizedOpenedReport
  );
  const {
      openFirstModal,
      handleFirstModalClick,
      handleSecondModalClick,
      getSecondModalContent,
      isMaxAllowedCardsLimitReached
    } = useRefreshActions();

  const { Text } = Typography;
  const { confirm } = Modal;
  const containerRef = useRef(null);

  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft -= 100;
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft += 100;
    }
  };

  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.PEBCommon?.userDetail); // get User details
  const editAccessFlag = useSelector(
    (state) => state.PEBCommon?.hasAccessToReport
  );
  const userId = userInfo.user_id;
  let [deletedComparator, setDeletedComparator] = useState([]);
  const [open, setOpen] = useState(props.visible);
  const [checkComparatorName, setCheckComparatorName] = useState(false);
  const analysisData = useSelector(
    (state) => state.PEBCommon?.findingsReport.analysisData
  );
  const isOpen = useSelector((state) => state.PEBCommon?.findingsReport.isOpen);
  const selectRef = useRef(null);

  const ageGroupsData = { ageGroups: [] };
  const initialAgeGroups = ageGroupsData.ageGroups;
  const [ageGroups, setAgeGroups] = useState([initialAgeGroups,initialAgeGroups,initialAgeGroups,initialAgeGroups,initialAgeGroups]);
  const [ageValidationMessage, setAgeValidationMessage] = useState("");
  const [dropdownOpenState, setDropdownOpenState] = useState([false,false,false,false,false]);
  const [openComparatorIndex, setOpenComparatorIndex] = useState(null);
  const [dropDownFieldDisabled,setDropDownFieldDisabled]=useState({"Criteria 1":true});
  const [stageDisabledFlag, setStageDisabledFlag] = useState({ });
  const [questionId , setQuestionId] = useState("");
  const [questionCategoryFlag , setQuestionCategoryFlag] = useState ("");
  const [questionResponseFlag , setQuestionResponseFlag] = useState ("");
  const [qualifyingQuesId, setQualifyingQuesId] = useState();
  const [otherIndicationFlag , setOtherIndicationFlag] = useState({0:true,1:true,2:true,3:true,4:true});
  // const [radioValue,setRadioValue] = useState('All');
  const [radioValue,setRadioValue] = useState([
    "All","All","All","All","All"
  ]);
  
  const checkCardLimitRunning = useSelector((state)=>state.PEBCommon?.refreshReport.checkCardLimitRunning);
  
  function hasDataInOtherFields(array) {
    const excludedFields = ['comparator_name', 'comparator_id', 'primary_flag','category_name'];
    
    return array.some(obj => {
        return Object.keys(obj).some(key => {
            // Skip the excluded fields
            if (excludedFields.includes(key)) {
                return false;
            }
            
            const value = obj[key];
            
            // Check if the field has data
            if (Array.isArray(value)) {
                return value.length > 0; // Array has elements
            } else {
                return value !== null && value !== undefined && value !== ''; // Non-empty value
            }
        });
    });
}



  // function allComparatorsEmpty(dataArray) {
  //   console.log("hulk",dataArray);
    
  //   return !dataArray?.some(obj => obj.is_empty_comparator === false);
  // }
    const shouldShowPopup = () => {
      const pilotUserNewSession = sessionStorage.getItem('pilotUserNewSession');
      
      if (pilotUserNewSession===true || pilotUserNewSession==="true") {        
        sessionStorage.setItem('pilotUserNewSession', false);
        return true;
      }
      
      return false;
    };
    


    // Show modal and auto close in 5 seconds
    const showModal = () => {      
      // setIsModalVisible(true);
      shouldShowPopup() && dispatch(setshowWarningMsg(true));

      setTimeout(() => {
        dispatch(setshowWarningMsg(false));
        // setIsModalVisible(false);
      }, 10000);
    };


  useEffect(() => {
  const handleClickOutside = (event) => {
    // Get all dropdown and select elements
    const dropdownElements = document.querySelectorAll('.ant-select-dropdown');
    const selectElements = document.querySelectorAll('.age-dropdown');
    
    let isClickOutside = true;
    
    // Check if the click is inside any dropdown or select element
    [...dropdownElements, ...selectElements].forEach(element => {
      if (element && element.contains(event.target)) {
        isClickOutside = false;
      }
    });
    
    // If click is outside, close all dropdowns

     if (isClickOutside) {
      setDropdownOpenState(prev => 
        prev.map(() => false)
      );
    }


  };

  // Add event listener
  document.addEventListener('mousedown', handleClickOutside);
  
  // Cleanup event listener on unmount
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);




  const handleCheckboxChange = (id,ind) => {
    setAgeValidationMessage("");
    setAgeGroups((prevAgeGroups) =>
      prevAgeGroups.map((group, index) => 
        index === ind 
          ? group.map((item) => 
              item.id === id 
                ? { ...item, selected: !item.selected } 
                : item
            ) 
          : group
      )
    );
  };

  // useEffect(()=>{
  //   console.log("exploreFilterApplyData",exploreFilterApplyData);
    
  // },[exploreFilterApplyData])

  //Confirmation Popup for Deleting an Analysis
  const showConfirm = () => {
    confirm({
      title: "Reset",
      icon: <ExclamationCircleOutlined />,
      content:
        "Are you sure you want to Reset ALL defined Filter Criteria, including all Comparator population criteria that has been defined?",
      okText: "Reset",
      className: "modal-delete",
      onOk() {
        filterResetHandler();
      },
      onCancel() {},
    });
  };

  const [filterCategoryData, setFilterCategoryData] = useState([
    {
      key: "1",
      comparatorName: "Criteria 1",
      comparator_id:null,
      filters: [
        // {
        //   key: "1",
        //   categoryKey: "therapeutic_area",
        //   categoryLabel: "Therapy Area",
        //   span: 24,
        //   openState: false,
        //   selectedValue: [],
        //   options: [],
        //   loading: false,
        //   selectAll: true,
        //   type: "dropdown",
        // },
        {
          key: "1",
          categoryKey: "primary_indication",
          categoryLabel: "Primary Indication",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
        {
          key: "2",
          categoryKey: "other_indication",
          categoryLabel: "Other Indication",
          isInfoIcon: true,
          infoMessage :"This filter will be accessible only when at least one primary indication has been selected",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
        {
          key: "3",
          categoryKey: "stage",
          categoryLabel: "Cancer Stage at Diagnosis",
          isInfoIcon: true,
          infoMessage :"This filter will be accessible only when one primary indication for oncology has been selected.",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
        {
          key: "14",
          categoryKey: "custom_region",
          categoryLabel: "Geography",
          span: 12,
          openState: false, // Can be removed for radio or used for collapsible radio groups
          selectedValue: "All", // Single string value for radio
          options: [
            { label: "All", value: "All" },
            { label: "US", value: "US" },
            { label: "Ex-US", value: "Ex-US" },
            
          ],
          loading: false,
          selectAll: false, // Not applicable for radio
          type: "radio",
        },
        {
          key: "15",
          categoryKey: "region",
          categoryLabel: "Global Region",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
         {
          key: "16",
          categoryKey: "geo_state",
          categoryLabel: "Country",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
        // {
        //   key: "4",
        //   categoryKey: "geography",
        //   categoryLabel: "Geography",
        //   span: 24,
        //   openState: false,
        //   selectedValue: [],
        //   options: [],
        //   loading: false,
        //   selectAll: true,
        //   type: "dropdown",
        // },
        {
          key: "5",
          categoryKey: "race",
          categoryLabel: "Race",
          isInfoIcon: true,
          infoMessage :"Find additional demographic details in the SDOH & Lifestyle category on the View Insights tab.",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
        {
          key: "6",
          categoryKey: "ethnicity",
          categoryLabel: "Ethnicity",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
        // {
        //   key: "6",
        //   categoryKey: "origin_country",
        //   categoryLabel: "Country of Origin",
        //   span: 24,
        //   openState: false,
        //   selectedValue: [],
        //   options: [],
        //   loading: false,
        //   selectAll: true,
        //   type: "dropdown",
        // },
        {
          key: "7",
          categoryKey: "age",
          categoryLabel: "Age",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown-custom",
        },
        {
          key: "8",
          categoryKey: "gender",
          categoryLabel: "Sex at Birth",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
        {
          key: "9",
          categoryKey: "survey_year",
          categoryLabel: "Time Period",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "survey-year-tree",
        },
        {
          key: "10",
          categoryKey: "custom_filter_label",
          categoryLabel: "Custom Filters",
          isInfoIcon: true,
          infoMessage :"Selecting category will not filter respondents unless a question is selected and upon selection of a question, the system will consider respondents who have answered that question.",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "custom-label",
        },
        {
          key: "11",
          categoryKey: "category_name",
          categoryLabel: "Insight Category",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "single-select-dropdown",
        },
        {
          key: "12",
          categoryKey: "question_id",
          categoryLabel: "Qualifying Question",
          span: 24,
          openState: false,
          selectedValue: [],
          selectedValueId:"",
          selectedValueType:[],
          options: [],
          loading: false,
          selectAll: true,
          type: "single-select-dropdown",
        },
        {
          key: "13",
          categoryKey: "lov_id",
          categoryLabel: "Qualifying Response",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
      
      ],
    },
  ]);
  const filterAppliedData = useSelector(
    (state) => state.PEBCommon?.exploreFilterApplyData
  );

  useEffect(() => {
    let category = filterCategoryData[0].filters.find(
      (ctg) => ctg.categoryKey === "primary_indication"
    );
    let category2 = filterCategoryData[0].filters.find(
      (ctg) => ctg.categoryKey === "geo_state"
    );

    const newRadioValue = Array.from({ length: 5 }, (_, index) => {
      if (index < filterAppliedData.length && filterAppliedData[index].custom_region?.[0]) {
        return filterAppliedData[index].custom_region[0];
      }
      return "All";
    });
        
    setRadioValue(newRadioValue);

   
    Promise.all([ 
      dropdownToggleHandler(true, category, 0), 
      dropdownToggleHandler(true, category2, 0)])
      .then(([data1,data2])=>{
      populateFilterData(data1,data2);
    });
  }, []);

  const populateFilterData = (treeData,geo_state_data) => {
    if (filterAppliedData && filterAppliedData.length) {
      let newState = filterAppliedData.map((data, index) => {
        let otherMappedData = data.other_mapped_data ? data.other_mapped_data : [];
        let primaryMappedData =data.mapped_data ? data.mapped_data : [];
        let surveyMappedData = data.survey_year_mapped_data ? data.survey_year_mapped_data : [];
        let geoStateMappedData = data?.geo_state_mapped_data;

        // If the data doesn't have __ separator, add it
        if (geoStateMappedData && Array.isArray(geoStateMappedData)) {
          geoStateMappedData = geoStateMappedData.map(item => {
            // If it's just a state name without country prefix, find its country
            if (!item.includes('__')) {
              // Try to find which country this state belongs to
              const matchingCountry = geo_state_data?.find(country => 
                country.children?.some(state => state.title === item)
              );
              if (matchingCountry) {
                return `${matchingCountry.title}__${item}`;
              }
            }
            return item;
          });
        }
        // let therapyArea = data.therapeutic_area ? data.therapeutic_area : []; 
        // let indications = data.indication
        //   ? data.indication.map((ind) => "i-" + ind)
        //   : [];
        // let sub_indications = data?.sub_indication ? data?.mapped_data : [];
        // let category = filterCategoryData[0].filters.find(
        //   (ctg) => ctg.categoryKey === "primary_indication"
        // );
        // sub_indications.forEach((value) => {
        //   let ind = getParentTitle(value, category.options);
        //   if (ind) {
        //     indications = indications.filter(
        //       (indication) => indication !== "i-" + ind
        //     );
        //   }
        // });
        return {
          key: index.toString(),
          comparatorName: data.comparator_name,
          filters: [
            // {
            //   key: "1",
            //   categoryKey: "therapeutic_area",
            //   categoryLabel: "Therapy Area",
            //   span: 24,
            //   openState: false,
            //   selectedValue: data.therapeutic_area || [],
            //   options: [],
            //   loading: false,
            //   selectAll: true,
            //   type: "dropdown",
            // },
            {
              key: "1",
              categoryKey: "primary_indication",
              categoryLabel: "Primary Indication",
              span: 24,
              openState: false,
              selectedValue: [...primaryMappedData] || [],
              options: treeData ? [...treeData] : [],
              loading: false,
              selectAll: true,
              type: "tree",
            },
            {
              key: "2",
              categoryKey: "other_indication",
              categoryLabel: "Other Indication",
              isInfoIcon: true,
              infoMessage :"This filter will be accessible only when at least one primary indication has been selected",
              span: 24,
              openState: false,
              selectedValue: [...otherMappedData] ||[],
              options:treeData ? [...treeData] : [],
              loading: false,
              selectAll: true,
              type: "tree",
            },
            {
              key: "3",
              categoryKey: "stage",
              categoryLabel: "Cancer Stage at Diagnosis",
              isInfoIcon: true,
              infoMessage :"This filter will be accessible only when one primary indication for oncology has been selected. ",
              span: 24,
              openState: false,
              selectedValue: data.stage || [],
              options: [],
              loading: false,
              selectAll: true,
              type: "dropdown",
            },
              {
                key: "14",
                categoryKey: "custom_region",
                categoryLabel: "Geography",
                span: 12,
                openState: false, // Can be removed for radio or used for collapsible radio groups
                selectedValue: data?.custom_region?.[0] || "All", // Single string value for radio
                // selectedValue: radioValue[index] || "All", // Single string value for radio

                options: [
                   { label: "All", value: "All" },
                  { label: "US", value: "US" },
                  { label: "Ex-US", value: "Ex-US" },
                 
                ],
                loading: false,
                selectAll: false, // Not applicable for radio
                type: "radio",
              },
            {
              key: "15",
              categoryKey: "region",
              categoryLabel: "Global Region",
              span: 24,
              openState: false,
              selectedValue: data.region || [],
              options: [],
              loading: false,
              selectAll: true,
              type: "dropdown",
            },
             {
              key: "16",
              categoryKey: "geo_state",
              categoryLabel: "Country",
              span: 24,
              openState: false,
              selectedValue: geoStateMappedData || [],
              options: geo_state_data ? [...geo_state_data] : [],
              loading: false,
              selectAll: true,
              type: "tree",
            },
            // {
            //   key: "4",
            //   categoryKey: "geography",
            //   categoryLabel: "Geography",
            //   span: 24,
            //   openState: false,
            //   selectedValue: data.geography || [],
            //   options: [],
            //   loading: false,
            //   selectAll: true,
            //   type: "dropdown",
            // },
            {
              key: "5",
              categoryKey: "race",
              categoryLabel: "Race",
              isInfoIcon: true,
              infoMessage :"Find additional demographic details in the SDOH & Lifestyle category on the View Insights tab.",
              span: 24,
              openState: false,
              selectedValue: data.race || [],
              options: [],
              loading: false,
              selectAll: true,
              type: "dropdown",
            },
            {
              key: "6",
              categoryKey: "ethnicity",
              categoryLabel: "Ethnicity",
              span: 24,
              openState: false,
              selectedValue: data.ethnicity || [],
              options: [],
              loading: false,
              selectAll: true,
              type: "dropdown",
            },
            // {
            //   key: "6",
            //   categoryKey: "origin_country",
            //   categoryLabel: "Country of Origin",
            //   span: 24,
            //   openState: false,
            //   selectedValue: data.origin_country || [],
            //   options: [],
            //   loading: false,
            //   selectAll: true,
            //   type: "dropdown",
            // },
            {
              key: "7",
              categoryKey: "age",
              categoryLabel: "Age",
              span: 24,
              openState: false,
              selectedValue: data.age || [],
              options: [],
              loading: false,
              selectAll: true,
              type: "dropdown-custom",
            },
            {
              key: "8",
              categoryKey: "gender",
              categoryLabel: "Sex at Birth",
              span: 24,
              openState: false,
              selectedValue: data.gender || [],
              options: [],
              loading: false,
              selectAll: true,
              type: "dropdown",
            },
            {
              key: "9",
              categoryKey: "survey_year",
              categoryLabel: "Time Period",
              span: 24,
              openState: false,
              selectedValue: [...surveyMappedData] || [],
              options: [],
              loading: false,
              selectAll: true,
              type: "survey-year-tree",
            },
            {
              key: "10",
              categoryKey: "custom_filter_label",
              categoryLabel: "Custom Filters",
              isInfoIcon: true,
              infoMessage :"Selecting category will not filter respondents unless a question is selected and upon selection of a question, the system will consider respondents who have answered that question.",
              span: 24,
              openState: false,
              selectedValue: [],
              options: [],
              loading: false,
              selectAll: true,
              type: "custom-label",
            },
            {
              key: "11",
              categoryKey: "category_name",
              categoryLabel: "Insight Category",
              span: 24,
              openState: false,
              selectedValue: data.category || [],
              options: [],
              loading: false,
              selectAll: true,
              type: "single-select-dropdown",
            },
            {
              key: "12",
              categoryKey: "question_id",
              categoryLabel: "Qualifying Question",
              span: 24,
              openState: false,
              selectedValue: data.ques_alias || [],
              selectedValueId:"",
              selectedValueType:data.ques_type || [],
              options: [],
              loading: false,
              selectAll: true,
              type: "single-select-dropdown",
            },
            {
              key: "13",
              categoryKey: "lov_id",
              categoryLabel: "Qualifying Response",
              span: 24,
              openState: false,
              selectedValue: data.lov_id_mapped_data || [],
              options: data.lov_id_options || [],
              loading: false,
              selectAll: true,
              type: "tree",
            },
            
          ],
        };
      });
      setFilterCategoryData([...newState]);

      // To enable or disable statge filter, just toggle primary_indication DD, 
      // then statge DD will take its right diable state.
      newState.map((_, index) => {
        let temp = _.filters.find((ctg) => ctg.categoryKey === "primary_indication");
        dropdownToggleHandler(false, temp, index);
      });
    }
  };

  const onClose = () => {
    setOpen(false);
    props.onClose();
  };

  //to transform the selected tree data from dropdown for ta,indication,sub-indication
  const transformSelectedData = (data) => {
    const result = {};

    data.forEach((item) => {
      const parts = item.split(/i-|si-/);

      const therapeuticAreaPart = parts.find((part) => part.startsWith('t-'));
      const indicationPart = parts[1];
      const subIndicationPart = parts[2];

      const therapeuticArea = therapeuticAreaPart
        ? therapeuticAreaPart.replace('t-', '')
        : parts[0];
      const indication = indicationPart ? indicationPart.replace('i-', '') : '';
      const subIndication = subIndicationPart
        ? subIndicationPart.replace('si-', '')
        : '';

      if (!result[therapeuticArea]) {
        result[therapeuticArea] = {
          therapeutic_area: therapeuticArea,
          indication_node: [],
        };
      }

      if (indication && !subIndication) {
        result[therapeuticArea].therapeutic_area = '';
        result[therapeuticArea].indication_node.push({
          indication: indication,
          sub_indication: [],
        });
      }

      if (indication && subIndication) {
        result[therapeuticArea].therapeutic_area = '';
        let ind = result[therapeuticArea].indication_node.find(
          (i) => i.indication === indication
        );
        if (!ind) {
          ind = { indication: indication, sub_indication: [] };
          result[therapeuticArea].indication_node.push(ind);
        }
        ind.sub_indication.push(subIndication);
      }
    });

    return Object.values(result).map((ta) => {
      ta.indication_node = ta.indication_node.map((ind) => {
        if (ind.sub_indication.length > 0) {
          return {
            indication: '',
            sub_indication: ind.sub_indication,
          };
        }
        return ind;
      });
      return ta;
    });
  };

  //transform survey year dropdown selected data
  const transformSurveyYear = (selectedData) => {
    let obj = {};
    const transformedData = {
      year_range: [],
      survey_year: [],
    };

    // Transforming the selected data
    selectedData.forEach((item) => {
      // const yearMatch = item.match(/y-(\d{4})/); // Matches items like "y-2024"
      // const rangeMatch = item.match(/r-(H\d) - (\d{4})/); // Matches items like "r-H1 - 2024"

      const yearMatch = item.match(/^(\d{4})$/); // Matches items like "2024"
      const rangeMatch = item.match(/(\d{4}) (H\d) - (\d{4})/);

      if (yearMatch) {
        if (!transformedData.survey_year.includes(yearMatch[1])) {
          transformedData.survey_year.push(yearMatch[1]);
        }
      }
      if (rangeMatch) {
        transformedData.year_range.push(`${rangeMatch[2]} - ${rangeMatch[3]}`);

        if (!transformedData.survey_year.includes(rangeMatch[1])) {
          transformedData.survey_year.push(rangeMatch[1]);
        }
      }
    });

    obj["survey_year"] = transformedData.survey_year;
    obj["year_range"] = transformedData.year_range;
    return obj;
  };

  const transformLovIdData = (data) => {
    const parsedData = data.map(item => {
      const [lovId, rank] = item.split(" ").map(Number);
      return { 
        lovId: lovId ? String(lovId) : null, 
        rank: rank || null     
      };
    });
  
    const uniqueLovIds = [...new Set(parsedData.map(item => item.lovId))].filter(id => id !== null);
    const ranks = parsedData.map(item => item.rank).filter(rank => rank !== null);
  
    return {
      lov_id: uniqueLovIds,
      rank: ranks
    };
  };

  const saveFilterDataHandler = () => {
    saveFilterDataPayload();
  };
  function anyTwoComparatorNamesSame(arr) {
    const comparatorNameSet = new Set();

    for (const obj of arr) {
      if (comparatorNameSet.has(obj.comparatorName)) {
        return true;
      }
      comparatorNameSet.add(obj.comparatorName);
    }
    return false;
  }

  function transformGeoData(category) {
    const result = [];

    if (category.categoryKey !== "geo_state") return result;

    const selected = Array.isArray(category.selectedValue)
      ? category.selectedValue
      : category.selectedValue ? [category.selectedValue] : [];

    const selectedSet = new Set(selected);
    
    // Handle special case: "Unspecified__Country" format
    const specialCases = new Map(); // country -> Set of special states
    
    selected.forEach(item => {
      if (typeof item === 'string' && item.includes('__')) {
        const [state, country] = item.split('__');
        if (!specialCases.has(country)) {
          specialCases.set(country, new Set());
        }
        specialCases.get(country).add(state);
      }
    });

    category.options.forEach(country => {
      const countryName = country.title;

      // If country itself is selected
      const isCountrySelected = selectedSet.has(countryName);
      
      // Check for special case states for this country
      const specialStates = specialCases.get(countryName) || new Set();

      if (!country.children || country.children.length === 0) {
        // Country has no children
        if (isCountrySelected) {
          result.push({ geography: countryName, state: [] });
        } else if (specialStates.size > 0) {
          // Only special states for this country
          result.push({ geography: countryName, state: Array.from(specialStates) });
        }
        return;
      }

      // Check which regular states are selected
      const stateList = country.children.map(child => child.title);
      const selectedStates = country.children
        .filter(child => selectedSet.has(child.value)) // Use child.value which is "Country__State"
        .map(child => child.title); // But push only the state name      
      // Combine regular selected states with special states
      const allSelectedStates = [...selectedStates, ...Array.from(specialStates)];

      if (isCountrySelected || selectedStates.length === stateList.length) {
        // Full country selected or all its regular states are selected
        // Note: If there are special states, we still include them
        if (specialStates.size > 0 && !isCountrySelected) {
          result.push({ geography: countryName, state: allSelectedStates });
        } else {
          result.push({ geography: countryName, state: [] });
        }
      } else if (allSelectedStates.length > 0) {
        // Some states selected (regular or special)
        result.push({ geography: countryName, state: allSelectedStates });
      }
    });

    return result;
  }


  const saveFilterDataPayload = () => {
    // console.log("thor filterCategoryData",filterCategoryData);
    
    const anyTwoComparatorNamesMatch =
      anyTwoComparatorNamesSame(filterCategoryData);
    if (anyTwoComparatorNamesMatch) {
      setCheckComparatorName(true);
      return true;
    } else {
      setCheckComparatorName(false);
    }
    const filters_data = filterCategoryData.map((comparator, index) => {
      let obj = { comparator_name: comparator.comparatorName };
      comparator.filters.forEach((category) => {
        console.log("category",category);
        
        if (category.categoryKey === "primary_indication") {
          let indicationArray = [];
          category?.selectedValue?.forEach((pIndication) => {
            category?.options?.forEach((disease) => {
              if (pIndication === disease?.key && disease?.children?.length === 1) {
                indicationArray.push(disease?.children[0].title);
              }
            });
          });

          // YS adding one more key for id 
          obj["comparator_id"] = exploreFilterApplyData[Number(filterCategoryData[index].key)]?.comparator_id || null;
          obj["primary_indication"] = transformSelectedData(category.selectedValue);
          obj["mapped_data"] = category.selectedValue;
          obj["indication"] = indicationArray;
          obj["therapeutic_area"] = [];
          category.selectedValue.forEach((value) => {
            let firstElement = value.split("i-")[0].trim();
            if (firstElement.startsWith("t-")) {
              firstElement = firstElement.substring(2);
            }
            obj["therapeutic_area"].push(firstElement);
          });
          category.selectedValue.forEach((value) => {
            if (value.split("si-").length === 1) {
              let ind = value.split("i-")[1];
              if (ind) {
                obj["indication"].push(ind);
              }
            }
          });
          obj["sub_indication"] = [];
          category.selectedValue.forEach((value) => {
            if (value.split("si-").length > 1) {
              let sub_ind = value.split("si-")[1];
              obj["sub_indication"].push(sub_ind);
              let ind = getParentTitle(value, category.options);
              if (ind) obj["indication"].push(ind);
            }
          });
          obj["therapeutic_area"] = [...new Set(obj["therapeutic_area"])];

          // Only include a TA in indication if it was selected as a whole TA (t- prefix),
          // not when only child indications inside it were selected
          const wholeTAs = category.selectedValue
            .filter(v => v.startsWith("t-"))
            .map(v => v.slice(2));

          obj["indication"] = [...new Set([...obj["indication"], ...wholeTAs])];
        }else if (category.categoryKey === "other_indication") {
          if( obj["primary_indication"].length==0 &&  obj["mapped_data"].length==0 ){
            obj["other_indication"] = [];
            obj["other_mapped_data"] = [];
          }
          else{
            obj["other_indication"] = transformSelectedData(category.selectedValue);
            obj["other_mapped_data"] = category.selectedValue;
          }
        } else if (category.categoryKey === "survey_year") {
          const trandformedValues = transformSurveyYear(category.selectedValue);
          obj["survey_year"] = trandformedValues?.survey_year;
          obj["year_range"] = trandformedValues?.year_range;
          obj["survey_year_mapped_data"] = category.selectedValue
        } else if(category.categoryKey === "lov_id"){
          // console.log("category.selectedValue" , category)
          const transformData = transformLovIdData (category.selectedValue);
          obj[category.categoryKey] = category?.selectedValue?.length > 0 ? [transformData] : category.selectedValue;
          obj['lov_id_mapped_data'] = category.selectedValue;
          if(category.selectedValue.length==0){
            obj['lov_id_options'] = []
          }
          else{
            obj['lov_id_options'] = category.options;
          }
        } else if (category.categoryKey === "category_name"){
          obj[category.categoryKey] = category.selectedValue === undefined ? [] : Array.isArray(category.selectedValue) ?category.selectedValue :[category?.selectedValue];
        }else if (category.categoryKey === "custom_region"){
          obj[category.categoryKey] = category.selectedValue === undefined || category.selectedValue==="All" ? [] : Array.isArray(category.selectedValue) ?category.selectedValue :[category?.selectedValue];
        }
        else if (category?.categoryKey === "geo_state"){
          obj["geo_state_mapped_data"] = category?.selectedValue;
          obj[category.categoryKey] = transformGeoData(category);
        }
        // else if (category.categoryKey === "region"){
        //   console.log("thor",obj["custom_region"],obj["region"]);
          
          
        //    if( obj["custom_region"] === "All" ){
        //     obj["region"] = category.selectedValue;
        //     // obj["other_mapped_data"] = [];
        //   }
        //   else{
        //     obj["region"] = [];
        //   }
        // }
        else if (category.categoryKey === "question_id"){
          obj["ques_alias"] = category.selectedValue === undefined ? [] : Array.isArray(category.selectedValue) ? category.selectedValue : [category.selectedValue];
          obj['ques_id'] = qualifyingQuesId ? [qualifyingQuesId] : [];
          if(qualifyingQuesId){
            obj['ques_type'] = (Array.isArray(category.selectedValueType) && category.selectedValueType.every(val => val === null)) 
            || category.selectedValueType === undefined
            ? []
            : Array.isArray(category.selectedValueType)
            ? category.selectedValueType
            : [category.selectedValueType];
          }
          else{
            obj['ques_type'] = [];
          }
        }
        else {
          obj[category.categoryKey] = category.selectedValue;
        }
      });
      obj["primary_flag"] = index === 0 ? true : false;
      return obj;
    });

    
    const filterApplied = hasDataInOtherFields(filters_data);
   
    if(filterApplied && userInfo?.pilot_active ){
      showModal();
    }
    
    let payload = {
      user_id: userId,
      screen_name: "data_coverage",
      comparator_flag: true,
      delete_comparator_names: deletedComparator,
      filters_data,
      display_chart_nm: [],
      analysis_id: localStorage.getItem("analysisId") || "",
    };


    // YS as we don't have to call api on apply
    // if we are coming through refresh route
    // so just saving the filters
    if(refreshScreen){
      // handleFirstModalClick('refreshData',filterExportLibraryCurrentPageData[disableReportIndex]);
      // isMaxAllowedCardsLimitReached
      // if(maxReportCards>=MAX_ALLOWED_CARDS){
      //   // call api to check if it is below limit or not

      // }
      // else{
        const updatedFiltersData = filters_data.map(obj => {
          const {
            comparator_name,
            comparator_id,
            mapped_data,
            other_mapped_data,
            survey_year,
            survey_year_mapped_data,
            custom_filter_label,
            category_name,
            ques_alias,
            lov_id_mapped_data,
            lov_id_options,
            primary_flag,
            ...rest
          } = obj;
        
          return {
            comparator_nm: comparator_name,
            ...rest
          };
        });
        

        handleCardLimitCheck(updatedFiltersData,filters_data);

        // let cardLimitReached = isMaxAllowedCardsLimitReached(updatedFiltersData);
        // if(cardLimitReached==true){
        //   alert("if",cardLimitReached)
        //   return;
        // }
        // else{
        //   alert("else");
        //   handleFirstModalClick('refreshData',filterExportLibraryCurrentPageData[disableReportIndex]);
        //   dispatch(setTargetPopulationFilterData(filters_data));
        //   onClose();
        // }

        // const payload = {
        //   user_id: userInfo.user_id,
        //   analysis_id: oldAnalysisId || "",
        //   screen_name: "analysis_library",
        //   analysis_refresh_type: "refresh_current",
        //   comparator_data:updatedFiltersData
        //   // ...(refreshNewlyCreatedReport && { new_analysis_id: analysis_id })
        // };
        // checkCardLimitFn(payload,filters_data);
        // let totalCards = response?.result?.total_number_of_cards;
        // if(totalCards>MAX_ALLOWED_CARDS){
        //   return;
        // }
        // else{
        //   dispatch(setTargetPopulationFilterData(filters_data));
        // }


        // call refresh api with filter data
        // saveFilterData(payload);
        // return;
      // }

    }
    else{
      saveFilterData(payload);
    }







  //  saveFilterData(payload);
  };
  const handleCardLimitCheck = async (updatedFiltersData,filters_data) => {
    let cardLimitReached = await isMaxAllowedCardsLimitReached(updatedFiltersData);
  
    if (cardLimitReached) {
      // alert("if", cardLimitReached);
      // stay on modal and let user edit filter
      return;
    } else {
      // alert("else");
      // proceed to next modal
      handleFirstModalClick('refreshData', filterExportLibraryCurrentPageData[disableReportIndex]);
      dispatch(setTargetPopulationFilterData(filters_data));
      onClose();
    }
  };
  
  // const checkCardLimitFn = async (payload,filters_data) => {
  //   let response = await checkCardLimit(payload);
  //   let totalCards = response?.result?.total_number_of_cards;
  //       if(totalCards>MAX_ALLOWED_CARDS){
  //         return;
  //       }
  //       else{
  //         // proceed
  //         handleFirstModalClick('refreshData',filterExportLibraryCurrentPageData[disableReportIndex]);
  //         dispatch(setTargetPopulationFilterData(filters_data));
  //       }

  //   // return response;
  //   // setDeletedComparator([]);
  //   // onClose(); //after save success
  //   //dispatch(setExploreFilterApplyData(payload.filters_data));
  //   // onClose(payload);
  // };
  //API call to Save Dropdowns Data
  const saveFilterData = async (payload) => {
    let response = await saveExploreFilterAPI(payload);
    setDeletedComparator([]);
    onClose(); //after save success
    //dispatch(setExploreFilterApplyData(payload.filters_data));
    // onClose(payload);
  };

  const filterResetHandler = () => {
    const newState = filterCategoryData.map((category, index) => {
      category.comparatorName = `Criteria ${index + 1}`;
      category.filters = [
        // {
        //   key: "1",
        //   categoryKey: "therapeutic_area",
        //   categoryLabel: "Therapy Area",
        //   span: 24,
        //   openState: false,
        //   selectedValue: [],
        //   options: [],
        //   loading: false,
        //   selectAll: true,
        //   type: "dropdown",
        // },
        {
          key: "1",
          categoryKey: "primary_indication",
          categoryLabel: "Primary Indication",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
        {
          key: "2",
          categoryKey: "other_indication",
          categoryLabel: "Other Indication",
          isInfoIcon: true,
          infoMessage :"This filter will be accessible only when at least one primary indication has been selected",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
        {
          key: "3",
          categoryKey: "stage",
          categoryLabel: "Cancer Stage at Diagnosis",
          isInfoIcon: true,
          infoMessage :"This filter will be accessible only when one primary indication for oncology has been selected.",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
          {
          key: "14",
          categoryKey: "custom_region",
          categoryLabel: "Geography",
          span: 12,
          openState: false, // Can be removed for radio or used for collapsible radio groups
          selectedValue: "All", // Single string value for radio
          options: [
            { label: "All", value: "All" },
            { label: "US", value: "US" },
            { label: "Ex-US", value: "Ex-US" },
            
          ],
          loading: false,
          selectAll: false, // Not applicable for radio
          type: "radio",
        },
        {
          key: "15",
          categoryKey: "region",
          categoryLabel: "Global Region",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
         {
          key: "16",
          categoryKey: "geo_state",
          categoryLabel: "Country",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
        // {
        //   key: "4",
        //   categoryKey: "geography",
        //   categoryLabel: "Geography",
        //   span: 24,
        //   openState: false,
        //   selectedValue: [],
        //   options: [],
        //   loading: false,
        //   selectAll: true,
        //   type: "dropdown",
        // },
        {
          key: "5",
          categoryKey: "race",
          categoryLabel: "Race",
          isInfoIcon: true,
          infoMessage :"Find additional demographic details in the SDOH & Lifestyle category on the View Insights tab.",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
        {
          key: "6",
          categoryKey: "ethnicity",
          categoryLabel: "Ethnicity",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
        // {
        //   key: "6",
        //   categoryKey: "origin_country",
        //   categoryLabel: "Country of Origin",
        //   span: 24,
        //   openState: false,
        //   selectedValue: [],
        //   options: [],
        //   loading: false,
        //   selectAll: true,
        //   type: "dropdown",
        // },
        {
          key: "7",
          categoryKey: "age",
          categoryLabel: "Age",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown-custom",
        },
        {
          key: "8",
          categoryKey: "gender",
          categoryLabel: "Sex at Birth",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
        {
          key: "9",
          categoryKey: "survey_year",
          categoryLabel: "Time Period",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "survey-year-tree",
        },
        {
          key: "10",
          categoryKey: "custom_filter_label",
          categoryLabel: "Custom Filters",
          isInfoIcon: true,
          infoMessage :"Selecting category will not filter respondents unless a question is selected and upon selection of a question, the system will consider respondents who have answered that question.",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "custom-label",
        },
        {
          key: "11",
          categoryKey: "category_name",
          categoryLabel: "Insight Category",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "single-select-dropdown",
        },
        {
          key: "12",
          categoryKey: "question_id",
          categoryLabel: "Qualifying Question",
          span: 24,
          openState: false,
          selectedValue: [],
          selectedValueId:"",
          selectedValueType:[],
          options: [],
          loading: false,
          selectAll: true,
          type: "single-select-dropdown",
        },
        {
          key: "13",
          categoryKey: "lov_id",
          categoryLabel: "Qualifying Response",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
       
      ];
      return category;
    });
    const currentData = filterAppliedData;
    const updatedData = currentData.map(item => ({
      ...item,
      ques_id: []
    }));

    dispatch(setExploreFilterApplyData(updatedData));

    setFilterCategoryData([...newState]);
    setStageDisabledFlag({ });
    setQuestionCategoryFlag("");
    setQuestionResponseFlag("");
    setQualifyingQuesId("");
    setOtherIndicationFlag({});
  };

  const options = [];
  for (let i = 10; i < 36; i++) {
    const value = i.toString(36) + i;
    options.push({
      label: `${value}`,
      value,
    });
  }
  const [value, setValue] = useState(["a10", "c12", "h17", "j19", "k20"]);
  const selectProps = {
    mode: "multiple",

    style: {
      width: "100%",
    },
    virtual: false,

    // value,
    placeholder: "All",
    maxTagCount: "responsive",
    allowClear: editAccessFlag,
  };

  const singleSelectProps = {
    mode: "single",

    style: {
      width: "100%",
    },
    virtual: false,

    // value,
    placeholder: "All",
    maxTagCount: "responsive",
    allowClear: editAccessFlag,
  };

  const filterALLIndications = (inputArray) => {
    const results = [];

    inputArray.forEach(item => {
      if (item.includes("i-")) {
        const iIndex = item.indexOf("i-");
        const valueAfterI = item.substring(iIndex + 2);
        const siIndex = valueAfterI.indexOf(" si-");
        const indication = siIndex !== -1
          ? valueAfterI.substring(0, siIndex).trim()
          : valueAfterI.trim();

        if (indication && !results.includes(indication)) {
          results.push(indication);
        }
      }
      // If it's a plain indication string (no prefix), include it directly
      else if (!item.startsWith("t-") && item.trim()) {
        if (!results.includes(item.trim())) {
          results.push(item.trim());
        }
      }
    });

    return results;
  };

  const radioChangeHandler = (e, category, index, comparatorName) => {
  const newValue = e.target.value; // Single value for radio (not an array)
 
    let temp = [...radioValue];
    temp[index] = newValue;
    
  setRadioValue(temp);

  // Note: lov_id logic is removed as it's specific to multi-select dropdowns
  // Radio buttons don't need parent-child selection logic
  
  const updatedState = filterCategoryData.map((comparator) => {
    return {
      ...comparator,
      filters: comparator.filters.map((filter) => {
        // if (category.categoryKey === "category_name" && filter.categoryKey === "category_name") {
        //   filter.selectedValue = newValue;
        //   const quesId = category.options.filter(
        //     (response) => response.value === newValue
        //   );
        //   quesId?.length > 0 && setQualifyingQuesId(quesId[0]?.ques_id);              
        //   filter.selectedValueId = quesId[0]?.ques_id;
        //   filter.selectedValueType = quesId[0]?.ques_type;
        //   setQuestionCategoryFlag(newValue);
        //   if(!newValue){
        //     setQuestionCategoryFlag("");
        //     setQuestionResponseFlag("");
        //     setQualifyingQuesId("");
        //   } 
        //   // Clear question_id and lov_id whenever category_name changes
        //   const questionFilter = comparator.filters.find(f => f.categoryKey === "question_id");
        //   const responseFilter = comparator.filters.find(f => f.categoryKey === "lov_id");
        //   if (questionFilter){
        //     setQuestionResponseFlag("");
        //     questionFilter.selectedValue = ""; // Empty string for radio
        //   } 
        //   if (responseFilter) responseFilter.selectedValue = []; // Keep as array if it's still a dropdown
        // } else if (category.categoryKey === "question_id" && filter.categoryKey === "question_id") {
        //   filter.selectedValue = newValue;
        //   setQuestionResponseFlag(newValue);
        //   if(!newValue) setQuestionResponseFlag("");
        //   const responseFilter = comparator.filters.find(f => f.categoryKey === "lov_id");
        //   if (responseFilter) responseFilter.selectedValue = [];
        //   const qualifyingResponseFilter = category.categoryKey === "question_id";
        //   if (qualifyingResponseFilter) {
        //     const quesId = category.options.filter(
        //       (response) => response.value === newValue
        //     );
        //     if(quesId?.length > 0) {
        //       setQualifyingQuesId(quesId[0]?.ques_id);
        //       filter.selectedValueId = quesId[0]?.ques_id;
        //       filter.selectedValueType = quesId[0]?.ques_type;
        //     }
        //   }
        // } 
        // else 
        if (filter.categoryKey === category.categoryKey && comparator.comparatorName === comparatorName && Number(comparator.key) === index) {
          // Update the specific radio only within the current comparator
          filter.selectedValue = newValue;
        }

        return filter;
      }),
    };
  });
  
  const newState = [...filterCategoryData];
  let resetRegionAndCountry = false;
  newState[index].filters = newState[index].filters.map((filter) => {
    if (filter?.categoryKey === category.categoryKey) {
      filter.selectedValue = newValue;
    }
    if(filter?.categoryKey === "custom_region"){
      if(newValue!="All"){ // Check if value is empty for radio
        // if primary indication is empty then set other indication empty
        resetRegionAndCountry = true;
      }
    }
    if(filter.categoryKey === "region"){        
      if(resetRegionAndCountry){          
        filter.selectedValue = [];
      }
    }
     if(filter.categoryKey === "geo_state"){        
      if(resetRegionAndCountry){          
        filter.selectedValue = [];
      }
    }
    

    return filter;
  });
  
  setFilterCategoryData(updatedState);
};

  const dropdownToggleHandler = (event, category, index) => {
    // console.log("dropdownToggleHandler +++++++++++", event, category, index);
    if (category.type === "dropdown-custom") {
       setDropdownOpenState((prevState) => 
      prevState.map((item, i) => (i === index ? true : false)));
      setOpenComparatorIndex(index); // Set the open comparator index
    }

    if(category.categoryKey === "primary_indication"){
      if(category.selectedValue.length > 0){
      checkStageFilter(category.selectedValue , index)
     }
     else{
      // checkStageFilter(filterAppliedData[index]?.mapped_data || [], index)
     }
    }

    if(filterAppliedData[index]?.ques_id.length && !qualifyingQuesId ){
      // console.log("111111111111111" , filterCategoryData[index].filters);
      // const quesAlias = category.selectedValue === filterAppliedData[index]?.ques_alias[0] ? filterAppliedData[index]?.ques_alias[0] : "";
      setQualifyingQuesId(filterAppliedData[index]?.ques_id[0]);
      setQuestionResponseFlag(filterAppliedData[index]?.ques_alias[0]);
    }
    
    if(filterAppliedData[index]?.category.length && category.selectedValue !== undefined ){
      // console.log("222222222222");
      setQuestionCategoryFlag(filterAppliedData[index]?.category[0]);
    }

    if(filterCategoryData[index]){
      // console.log("undefinedddddddd" , filterCategoryData[index]?.filters)
      if(filterCategoryData[index]?.filters[11]?.selectedValue === undefined){
        setQualifyingQuesId("");
        setQuestionResponseFlag("");
      }
      if(filterCategoryData[index]?.filters[10]?.selectedValue === undefined){
        // console.log("category",filterCategoryData[index]?.filters[10])
        setQuestionCategoryFlag("");
        setQualifyingQuesId("");
        setQuestionResponseFlag("");
      }
    }

    if(category.categoryKey === "question_id" && (category?.selectedValue?.length === 0 || category.selectedValue === undefined)){
      // console.log("3333333333333")
      setQuestionResponseFlag("");
    }

    if(category.categoryKey === "category_name" && filterAppliedData[index]?.ques_id.length ){
      const quesAlias = category.selectedValue === filterAppliedData[index]?.category ? filterAppliedData[index]?.ques_alias[0] : "";
      setQuestionResponseFlag(quesAlias);
      setQualifyingQuesId("");

    }

    const qualifyingResponseFilter = category.categoryKey === "question_id";
    if (qualifyingResponseFilter) {
      const quesId = category.options.filter(
        (response) => response.value === category.selectedValue
      );
      setQualifyingQuesId(quesId[0]?.ques_id);
    }
    
    if (event) {
      return getDropdownPayload(category.categoryKey, index);
    }
  };
  // function checkPrimaryIndicationHasOneChild(data) {
  //   // Find the primary indication filter
  //   const primaryIndicationFilter = data.filters.find(
  //       filter => filter.categoryKey === "primary_indication"
  //   );
    
  //   if (!primaryIndicationFilter) {
  //       return [];
  //   }
    
  //   const selectedValues = primaryIndicationFilter.selectedValue;
  //   const options = primaryIndicationFilter.options;
  //   const childTitles = [];
    
  //   // Check each selected value
  //   for (const selectedValue of selectedValues) {
  //       // Find the matching option in the options array
  //       const matchingOption = findOptionByValue(options, selectedValue);
        
  //       if (matchingOption && matchingOption.children && matchingOption.children.length === 1) {
  //           childTitles.push(matchingOption.children[0].title);
  //       }
  //   }
    
  //   return childTitles;
  // }

  // Helper function to recursively find an option by its value
  function findOptionByValue(options, targetValue) {
      for (const option of options) {
          if (option.value === targetValue) {
              return option;
          }
          
          // Recursively search in children
          if (option.children && option.children.length > 0) {
              const found = findOptionByValue(option.children, targetValue);
              if (found) {
                  return found;
              }
          }
      }
      return null;
  }



  const getDropdownPayload = (column, index) => {
    let indication = [];
    let therapeutic_area = [];
    let sub_indication = [];
    let quesCategory = [];
    let quesValue = "";
    let quesId = "";
    let onlyIndicationList =[];
    switch (column) {
      case "therapeutic_area":
        indication = filterCategoryData[index].filters.filter(
          (category) => category.categoryKey === "primary_indication"
        )[0]?.selectedValue;
        sub_indication = filterCategoryData[index].filters.filter(
          (category) => category.categoryKey === "sub_indication"
        )[0]?.selectedValue;
        break;
      case "indication":
        therapeutic_area = filterCategoryData[index].filters.filter(
          (category) => category.categoryKey === "therapeutic_area"
        )[0]?.selectedValue;
        sub_indication = filterCategoryData[index].filters.filter(
          (category) => category.categoryKey === "sub_indication"
        )[0]?.selectedValue;
        break;
      case "sub_indication":
        therapeutic_area = filterCategoryData[index].filters.filter(
          (category) => category.categoryKey === "therapeutic_area"
        )[0]?.selectedValue;
        indication = filterCategoryData[index].filters.filter(
          (category) => category.categoryKey === "primary_indication"
        )[0]?.selectedValue;
        break;
      case "question_id":
        quesCategory = filterCategoryData[index].filters.filter(
          (category) => category.categoryKey === "category_name"
        )[0]?.selectedValue;
        break;
      case "lov_id":
        quesValue = filterCategoryData[index].filters.filter(
          (category) => category.categoryKey === "question_id"
        )[0]?.selectedValue;
         break;        
      case "age":
        break;
      default:
        break;
    }

    indication = filterCategoryData[index].filters.filter(
      (category) => category.categoryKey === "primary_indication"
    )[0]?.selectedValue;
    
    let region = filterCategoryData[index].filters.filter(
      (category) => category.categoryKey === "region"
    )[0]?.selectedValue;
    let custom_region = filterCategoryData[index].filters.filter(
      (category) => category.categoryKey === "custom_region"
    )[0]?.selectedValue;
    if(custom_region=="All"){
      custom_region = null;
    }
    

   if (indication) {
  const indicationNames = filterALLIndications(indication);
  // Only include TAs that were selected whole (t- prefix), not parent TAs of partial selections
  const wholeTAs = indication
    .filter(v => v.startsWith("t-"))
    .map(v => v.slice(2));
  onlyIndicationList = [...new Set([...indicationNames, ...wholeTAs])];
}
    
    const newState = filterCategoryData;
    newState[index].filters = filterCategoryData[index].filters?.map(
      (filter) => {
        if (filter.categoryKey === column) {
          filter.loading = true;
        }
        return filter;
      }
    );

    // have to check this as index is changed now
    // updated from 11 to 13 as added region and radio
    // replaced geography with geo-state
    const quesList = filterCategoryData[index].filters[13];
    let quesListVal = "";
    
    if(quesList?.selectedValueId && quesList?.selectedValueId.length){
      quesListVal = quesList?.selectedValueId ;
    }else if(qualifyingQuesId){
      quesListVal = qualifyingQuesId
    } else {
      quesListVal =filterAppliedData[index]?.ques_id[0] ;
    }

    setQualifyingQuesId(quesListVal);

    setFilterCategoryData([...newState]);
    let payload = {
      user_id: userId,
      search_string: "",
      screen_name: "data_coverage",
      // limit: 100,
      // offset: 0,
      column_name: column,
      indication : onlyIndicationList,
      therapeutic_area,
      sub_indication,
      allowed_geographies: userInfo?.allowed_geographies || [],
      allowed_indications:userInfo?.allowed_indications || []
    };

    const agePayload = {
      ...payload,
      comparator_name: newState[index].comparatorName,
    };

    // const primaryOneChild = checkPrimaryIndicationHasOneChild(filterCategoryData[0]);

    const quesIdPayload = {
      ...payload,
      category_name : Array.isArray(quesCategory) ? quesCategory[0] : quesCategory,
      question_id : "",
      indication: onlyIndicationList
    };
    const lovIdPayload = {
      ...payload,
      question_id : quesListVal,
    }
     const geoStatePayload = {
      ...payload,
      column_name:'geo_state',
      region:region,
      custom_region:custom_region?[custom_region]:[]
    }

    return column === "age"
      ? getFilterDropdownData(agePayload, index)
      // : column === "geography"
      // ? getFilterDropdownData(geographyPayload, index)
       : column === "geo_state" 
      ? getFilterDropdownData(geoStatePayload, index)
      : column === "question_id" 
      ? getFilterDropdownData(quesIdPayload, index)
      : column === "lov_id" 
      ? getFilterDropdownData(lovIdPayload, index)
      : getFilterDropdownData(payload, index);
  };

  //API call for Dropdown Data

  const getFilterDropdownData = async (payload, index) => {
    let response = await getExploreFilterDropdownDataAPI(payload);
    let options;
     if (payload.column_name === "geo_state") {
      const geoStateOptions = response.data.list_data;
      options = geoStateOptions?.map((data,i) => {
        return {
          title: data.geography,
          value: data.geography,
          key: data.geography,
          disabled: !data?.visible_flag,
          children: data.state.map((subData,j) => {
            return {
              title: subData,
              value: `${data.geography}__${subData}`,  // ✅ Make value unique
              key: `${data.geography}__${subData}`,    // ✅ Make key unique
              disabled: !data?.visible_flag,
              
            };
          }),
        };
      });
    }
    else if (payload.column_name === "primary_indication") {
      // const taOptions = INDICATION_TREE_STRUCTURE ;
      const taOptions = response.data.list_data;
      options = taOptions?.map((data,i) => {
        return {
          title: data.category,
          value: "t-" + data.category,
          key: "t-" + data.category,
          level:"t1",
          disabled: !data?.visible_flag,
          children: data.indications.map((subData,j) => {
            return {
              title: subData.indication,
              value: data.category + " i-" + subData.indication,
              key: data.category + " i-" + subData.indication,
              disabled: !subData?.visible_flag,
              children :subData.sub_indications.map(((subs,k)=>{
                return {
                  title :subs.sub_indication,
                  value : data.category + " i-" + subData.indication + " si-"+subs.sub_indication,
                  key :data.category + " i-" + subData.indication + " si-"+subs.sub_indication,
                  disabled: !subs?.visible_flag,
                }
              }))
            };
          }),
        };
      });
      // options = INDICATION_TREE_STRUCTURE
    }
    else if (payload.column_name === "other_indication") {
      // const taOptions = INDICATION_TREE_STRUCTURE ;
      const taOptions = response.data.list_data;
      options = taOptions?.map((data) => {
        return {
          title: data.category,
          value: "t-" + data.category,
          key: "t-" + data.category,
          level:"t1",
          children: data.indications.map((subData) => {
            return {
              title: subData.indication,
              value: data.category + " i-" + subData.indication,
              key: data.category + " i-" + subData.indication,
              children :subData.sub_indications.map(((subs)=>{
                return {
                  title :subs.sub_indication,
                  value : data.category + " i-" + subData.indication + " si-"+subs.sub_indication,
                  key :data.category + " i-" + subData.indication + " si-"+subs.sub_indication,
                }
              }))
            };
          }),
        };
      });
      // options = INDICATION_TREE_STRUCTURE
    }else if (payload.column_name === "survey_year" ) {
      const surveyYears = response.data.list_data;
      options = surveyYears?.map((data) => {
        return {
          title: data.value,
          value: data.value,
          key: data.value,
          level:"t1",
          children: data.year_range.map((subData) => {
            return {
              title: subData.value,
              value: data.value +" "+  subData.value,
              key: data.value +" " + subData.value,
            };
          }),
        };
      });
    } else if (payload.column_name === "lov_id" ) {
      const lovIdList = response.data.list_data;
      options = lovIdList?.map((data) => {
        return {
          title: data.lov_text,
          value: data.lov_id,
          key: data.lov_id,
          level:"t1",
          children: data?.lov_rank.map((subData) => {
            return {
              title: "Rank "+subData.rank,
              value: data.lov_id +" "+  subData.rank,
              key: data.lov_id +" " + subData.rank,
            };
          }),
        };
      });
    } 
    else if (payload.column_name === "age") {
      setAgeGroups((prevAgeGroups) => {
        // Check if the ageGroups at the specified index exists
        if (prevAgeGroups[index] && prevAgeGroups[index].length > 0) {
          return prevAgeGroups;
        }
  
        return prevAgeGroups.map((ageGroup, i) =>
          i === index
            ? [
                ...response.data.list_data,
                ...[
                  {
                    id: "",
                    name: "",
                    range: {
                      min: null,
                      max: null,
                    },
                    selected: false,
                  },
                ],
              ]
            : ageGroup
        );
      });
    } else if(payload.column_name === "question_id"){
      options = response.data.list_data?.map((data) => {
        return {
          label: data.value,
          value: data.value,
          disabled: !editAccessFlag,
          ques_id : data.ques_id,
          ques_type: data.ques_type
        };
      });
    } 
    else if(payload.column_name === "geography"){
        options = response.data.list_data?.map((data) => {
        return {
          label: data.value,
          value: data.value,
          // disablity for pilot
          disabled: !editAccessFlag || !data?.visible_flag,
        };
      });
    }
    else {      
      options = response.data.list_data?.map((data,i) => {
        return {
          label: data.value,
          value: data.value,
          disabled: !editAccessFlag ,
        };
      });
    }
    options = options?.sort((a, b) => {
    // If one is disabled and other is not, prioritize the enabled one
    if (a?.disabled !== b?.disabled) {
      return a.disabled - b.disabled; // false (0) comes before true (1)
    }
    // If both have same disabled status, sort alphabetically by label
    return a?.label?.localeCompare(b.label);
  });
    const newState = filterCategoryData;
    newState[index].filters = filterCategoryData[index].filters?.map(
      (filter) => {
        if (filter.categoryKey === payload.column_name) {
          filter.options = options;
          filter.loading = false;
        }
        return filter;
      }
    );

    setFilterCategoryData([...newState]);
    return options;
  };

  useEffect(() => {
  }, [ageGroups]);

const updateDropDownFieldDisabled =(comparatorName ,disable)=>{
  setDropDownFieldDisabled((prevData)=>(
    {
      ...prevData,
      [comparatorName]:disable 
    }
  ));
}

function duplicateSharedChild(treeData, sharedValue) {
  const clonedTree = JSON.parse(JSON.stringify(treeData)); // Deep clone to avoid mutating original

  function recurse(nodes, parentValue = '') {
    return nodes.map((node) => {
      const isParent = Array.isArray(node.children);
      if (!isParent) return node;

      const updatedChildren = node.children.map((child) => {
        if (child.value === sharedValue) {
          return {
            ...child,
            value: `${child.value}__${node.value}`, // make value unique per parent
            isShared: true, // Optional: mark for tracking
          };
        }
        return child;
      });

      return {
        ...node,
        children: recurse(updatedChildren, node.value),
      };
    });
  }

  return recurse(clonedTree);
}


  const dropdownChangeHandler = (newValue, category, index, comparatorName) => {
    // console.log("thor", newValue, category, index, comparatorName)
    if (category.categoryLabel.toLowerCase() === "primary indication") {
      updateDropDownFieldDisabled(comparatorName, newValue.length === 0);
      checkStageFilter(newValue,index)
    }
    if(category.categoryKey === "category_name"){
      setQuestionCategoryFlag(newValue);
      setQuestionResponseFlag("");
      // setQualifyingQuesId(null);
    }
    if(category.categoryKey === "question_id"){
      setQuestionResponseFlag(newValue);
    }

    // Check for "lov_id" type to enforce single parent selection rule
    if (category.categoryKey === "lov_id") {
      const currentParent = newValue.find(value => !value.includes(" ")); // parent has no space in value
      const selectedChildren = newValue.filter(value => value.includes(" ")); // child nodes contain space in value

      // Check if all selected child nodes are under the current parent
      const isConsistentSelection = selectedChildren.every(value => value.startsWith(currentParent));

      if (!isConsistentSelection) {
        const latestParent = selectedChildren[selectedChildren.length - 1].split(" ")[0]; // parent of the latest selected child
        newValue = newValue.filter(value => value.startsWith(latestParent) || value === latestParent);
      }
    }
    
    const updatedState = filterCategoryData.map((comparator) => {
      return {
        ...comparator,
        filters: comparator.filters.map((filter) => {
          // console.log("filters",filter);
          
          if(filter.categoryKey==="geo_state" && category.categoryKey==="region" && newValue.length!=0 && Number(comparator.key) === index){
            filter.selectedValue = [];
          }
          
          if (category.categoryKey === "category_name" && filter.categoryKey === "category_name") {
            filter.selectedValue = newValue;
            const quesId = category.options.filter(
              (response) => response.value === newValue
            );
            quesId?.length==0 && setQualifyingQuesId(quesId[0]?.ques_id);              
              filter.selectedValueId = quesId[0]?.ques_id;
              filter.selectedValueType = quesId[0]?.ques_type;
            setQuestionCategoryFlag(newValue);
            if(!newValue){
              setQuestionCategoryFlag("");
              setQuestionResponseFlag("");
              setQualifyingQuesId("");
            } 
            // Clear question_id and lov_id whenever category_name changes
            const questionFilter = comparator.filters.find(f => f.categoryKey === "question_id");
            const responseFilter = comparator.filters.find(f => f.categoryKey === "lov_id");
            if (questionFilter){
              // setQuestionCategoryFlag("");
              setQuestionResponseFlag("");
              questionFilter.selectedValue = [];
            } 
            if (responseFilter) responseFilter.selectedValue = [];
          } else  if (category.categoryKey === "question_id" && filter.categoryKey === "question_id") {
            filter.selectedValue = newValue;
            setQuestionResponseFlag(newValue);
            if(newValue === undefined) setQuestionResponseFlag("");
            const responseFilter = comparator.filters.find(f => f.categoryKey === "lov_id");
            if (responseFilter) responseFilter.selectedValue = [];
            const qualifyingResponseFilter = category.categoryKey === "question_id";
            if (qualifyingResponseFilter) {
              const quesId = category.options.filter(
                (response) => response.value === newValue
              );
              setQualifyingQuesId(quesId[0]?.ques_id);
              filter.selectedValueId = quesId[0]?.ques_id;
              filter.selectedValueType = quesId[0]?.ques_type;
            }

          } else if (filter.categoryKey === category.categoryKey && comparator.comparatorName === comparatorName && Number(comparator.key) === index) {
            // Update the specific dropdown only within the current comparator
            filter.selectedValue = newValue;
          }

          
          return filter;
        }),
      };
    });
    
    const newState = [...filterCategoryData];
    let resetOtherIndicationFlag = false;
    newState[index].filters = newState[index].filters.map((filter) => {
      if (filter?.categoryKey === category.categoryKey) {
        filter.selectedValue = newValue;
      }
      if(filter?.categoryKey === "primary_indication"){
        if(newValue?.length==0){
          // if primary indication is empty then set other indication empty
          resetOtherIndicationFlag = true;
        }
      }
      if(filter.categoryKey === "other_indication"){        
        if(resetOtherIndicationFlag){          
          filter.selectedValue = [];
        }
      }

      return filter;
    });
  
    setFilterCategoryData(updatedState);
  };

  const checkStageFilter = (newValue, index) => {

    filterCategoryData[index]?.filters.map((category) => {
      if (category.categoryKey === "stage") {
        category.selectedValue = [];
      }
    });

  // Update `setOtherIndicationFlag` for the current index
  setOtherIndicationFlag((prev) => ({
    ...prev,
    [index]: newValue.length === 0, // Set true if newValue is empty, else false
  }));

    const indications = newValue
      .map((item) => {
        if (item.includes("Oncology")) {
          const indicationMatch = item.match(/i-[^\s]+/);
          return indicationMatch ? indicationMatch[0] : null;
        }
      })
      .filter(Boolean);

    // Get unique indications
    const uniqueIndications = [...new Set(indications)];
// console.log("indicationsssss------",uniqueIndications , newValue)
    // const flag = uniqueIndications.length === 1;
    const hasOnlyOncology = newValue.every(item => item.includes("Oncology"));
    const hasSingleOncology = uniqueIndications.length === 1 && hasOnlyOncology;
  
    const flag = hasSingleOncology;
    setStageDisabledFlag(prev => {
      return {
        ...prev,
        [index]: flag
      }
    });
  };

  const [treeValue, setTreeValue] = useState([
    "Child Node3",
    "Child Node4",
    "Child Node5",
  ]);
  const onChange = (newValue) => {
    setTreeValue(newValue);
  };
  const tProps = {
    placeholder: "All",
    maxTagCount: "responsive",
    allowClear: editAccessFlag,
    treeCheckable: true,
    virtual: false,
    showCheckedStrategy: SHOW_PARENT,
    style: {
      width: "100%",
    },
  };

  const tPropsSurveyYear = {
    placeholder: "All",
    maxTagCount: "responsive",
    allowClear: editAccessFlag,
    treeCheckable: true,
    virtual: false,
    showCheckedStrategy: SHOW_ALL,
    style: {
      width: "100%",
    },
  };


  const addComparator = () => {
    setDropdownOpenState((prevState) => 
      prevState.map((item, i) => (i === filterCategoryData.length-1 ? false : false))); //closing age dropdown when we add new comparator
  
    // ADD LOGIC TO PREVENT DUPLICATE NAMES
    const newState = filterCategoryData;
    const comparatorName="Criteria " + (filterCategoryData.length + 1);

      // Get the last comparator to auto-populate certain fields
  const lastComparator = filterCategoryData[filterCategoryData.length - 1] || {};
  const lastSelectedValues = {
    category: lastComparator.filters?.find(f => f.categoryKey === "category_name")?.selectedValue || [],
    question: lastComparator.filters?.find(f => f.categoryKey === "question_id")?.selectedValue || [],
    questionId: lastComparator.filters?.find(f => f.categoryKey === "question_id")?.selectedValueId || [],
    questionListOptions: lastComparator.filters?.find(f => f.categoryKey === "question_id")?.options || [],
    questionType: lastComparator.filters?.find(f => f.categoryKey === "question_id")?.selectedValueType || [],
  };

    newState.push({
      key: (filterCategoryData.length + 1).toString(),
      comparatorName: comparatorName,
      filters: [
        // {
        //   key: "1",
        //   categoryKey: "therapeutic_area",
        //   categoryLabel: "Therapy Area",
        //   span: 24,
        //   openState: false,
        //   selectedValue: [],
        //   options: [],
        //   loading: false,
        //   selectAll: true,
        //   type: "dropdown",
        // },
        {
          key: "1",
          categoryKey: "primary_indication",
          categoryLabel: "Primary Indication",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
        {
          key: "2",
          categoryKey: "other_indication",
          categoryLabel: "Other Indication",
          isInfoIcon: true,
          infoMessage :"This filter will be accessible only when at least one primary indication has been selected",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
        {
          key: "3",
          categoryKey: "stage",
          categoryLabel: "Cancer Stage at Diagnosis",
          isInfoIcon: true,
          infoMessage :"This filter will be accessible only when one primary indication for oncology has been selected.",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
         {
          key: "14",
          categoryKey: "custom_region",
          categoryLabel: "Geography",
          span: 12,
          openState: false, // Can be removed for radio or used for collapsible radio groups
          selectedValue: "All", // Single string value for radio
          options: [
            { label: "All", value: "All" },
            { label: "US", value: "US" },
            { label: "Ex-US", value: "Ex-US" },
            
          ],
          loading: false,
          selectAll: false, // Not applicable for radio
          type: "radio",
        },
        {
          key: "15",
          categoryKey: "region",
          categoryLabel: "Global Region",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
         {
          key: "16",
          categoryKey: "geo_state",
          categoryLabel: "Country",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
        // {
        //   key: "4",
        //   categoryKey: "geography",
        //   categoryLabel: "Geography",
        //   span: 24,
        //   openState: false,
        //   selectedValue: [],
        //   options: [],
        //   loading: false,
        //   selectAll: true,
        //   type: "dropdown",
        // },
        {
          key: "5",
          categoryKey: "race",
          categoryLabel: "Race",
          isInfoIcon: true,
          infoMessage :"Find additional demographic details in the SDOH & Lifestyle category on the View Insights tab.",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
        {
          key: "6",
          categoryKey: "ethnicity",
          categoryLabel: "Ethnicity",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
        // {
        //   key: "6",
        //   categoryKey: "origin_country",
        //   categoryLabel: "Country of Origin",
        //   span: 24,
        //   openState: false,
        //   selectedValue: [],
        //   options: [],
        //   loading: false,
        //   selectAll: true,
        //   type: "dropdown",
        // },
        {
          key: "7",
          categoryKey: "age",
          categoryLabel: "Age",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown-custom",
        },
        {
          key: "8",
          categoryKey: "gender",
          categoryLabel: "Sex at Birth",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "dropdown",
        },
        {
          key: "9",
          categoryKey: "survey_year",
          categoryLabel: "Time Period",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "survey-year-tree",
        },
        {
          key: "10",
          categoryKey: "custom_filter_label",
          categoryLabel: "Custom Filters",
          isInfoIcon: true,
          infoMessage :"Selecting category will not filter respondents unless a question is selected and upon selection of a question, the system will consider respondents who have answered that question.",
          span: 24,
          openState: false,
          selectedValue: [],
          options: [],
          loading: false,
          selectAll: true,
          type: "custom-label",
        },
        {
          key: "11",
          categoryKey: "category_name",
          categoryLabel: "Insight Category",
          span: 24,
          openState: false,
          selectedValue: lastSelectedValues.category || [],
          options: [],
          loading: false,
          selectAll: true,
          type: "single-select-dropdown",
        },
        {
          key: "12",
          categoryKey: "question_id",
          categoryLabel: "Qualifying Question",
          span: 24,
          openState: false,
          selectedValue: lastSelectedValues.question || [],
          options: lastSelectedValues.questionListOptions || [],
          selectedValueId:lastSelectedValues.questionId || "",
          selectedValueType: lastSelectedValues.questionType || [],
          loading: false,
          selectAll: true,
          type: "single-select-dropdown",
        },
        {
          key: "13",
          categoryKey: "lov_id",
          categoryLabel: "Qualifying Response",
          span: 24,
          openState: false,
          selectedValue:lastSelectedValues.lov || [],
          options: [],
          loading: false,
          selectAll: true,
          type: "tree",
        },
       
      ],
    });

    setFilterCategoryData([...newState]);
    updateDropDownFieldDisabled(comparatorName,true);
  };

  const deleteCriteria = (index, comparatorName) => {
    setDeletedComparator([...deletedComparator, comparatorName]);
    const newState = filterCategoryData.filter((_, i) => index !== i);

    setFilterCategoryData([...newState]);
  };

  const comparatorRenameHandler = (event, index) => {
    // 
    const newState = filterCategoryData.map((category, i) => {
      if (i === index) category.comparatorName = event.target.value;
      return category;
    });

    setFilterCategoryData([...newState]);
  };


  // YS mapping id with filter data
  // ensuring it is not causing infinite renders

  const comparatorIdHandler = (event, index) => {
    const newValue = event?.target?.value;
    // console.log("newValue",newValue);
    if(newValue==undefined){
      return;
    }
    
    // Avoid unnecessary updates
    const isSame =
      filterCategoryData[index].comparator_id === newValue &&
      filterCategoryData.every((cat, i) => i === index || cat.comparator_id === null);
  
    if (isSame) return;
  
    const newState = filterCategoryData.map((category, i) => {
      return {
        ...category,
        comparator_id: i === index ? newValue : null,
      };
    });
  
    setFilterCategoryData(newState);
  };
  



  const treeDataWithDisabled = (items) =>
    items.map((item) => ({
      ...item,
      disabled: true,
      children:
        item.children &&
        item.children.map((child) => ({ ...child, disabled: true })),
    }));

    const checkAgeRangeValidations = (ageArrayList) => {

      // Check if more than 5 checkboxes are selected
      if (ageArrayList.length > 5) {
        setAgeValidationMessage("You can select a maximum of 5 age ranges.");
        return true;
      }

      // Helper function to check if age ranges overlap
      const isOverlap = (rangeA, rangeB) => {
        return !(rangeA[1] < rangeB[0] || rangeB[1] < rangeA[0]);
      };

      // Ensure both min and max ages are present and valid
      for (const age of ageArrayList) {
        const [minAge, maxAge] = age.age_value;

        if (
          !(
            age.age_value &&
            Array.isArray(age.age_value) &&
            age.age_value.length === 2
          ) ||
          isNaN(minAge) ||
          isNaN(maxAge) ||
          !Number.isInteger(minAge) ||
          !Number.isInteger(maxAge)
        ) {
          setAgeValidationMessage(
            "Each age entry must have both min and max age values as integers."
          );
          return true;
        } else if (minAge >= maxAge) {
          setAgeValidationMessage(
            "Please enter correct age range values for max and min age. Max age entered is less than Min age."
          );
          return true;
        }
      }

      // Check for duplicate labels
      const labelSet = new Set();
      for (const age of ageArrayList) {
        if (
          !age.age_label ||
          typeof age.age_label !== "string" ||
          age.age_label.trim() === ""
        ) {
          setAgeValidationMessage(
            "Age Range Label cannot be empty . Please add age range label."
          );
          return true;
        }
        if (!labelSet.has(age.age_label)) {
          labelSet.add(age.age_label);
          // return false;
        } else {
          setAgeValidationMessage(
            "Age Range Labels entered are not unique. Please enter unique age range labels."
          );
          return true;
        }
      }

      // Check for overlapping age ranges
      for (let i = 0; i < ageArrayList.length; i++) {
        for (let j = i + 1; j < ageArrayList.length; j++) {
          if (isOverlap(ageArrayList[i].age_value, ageArrayList[j].age_value)) {
            setAgeValidationMessage(
              "Age range entered are overlapping. Please enter distinct age ranges."
            );
            return true;
          } else {
            // return false;
          }
        }
      }
      return false;
    };

  const onFinish = (values, index , name) => {

    const ageArray = [];
    ageGroups[index].slice(0, 5).forEach((item) => {
      if (item.selected) {
        ageArray.push({
          age_label: item.name,
          age_value: [item.range.min, item.range.max],
        });
      }
    });
    values[`ageRanges${index}`].forEach((item) => {
      if (item.checked) {
        ageArray.push({
          age_label: item.name,
          age_value: [item.minAge, item.maxAge],
        });
      }
    });
    const validationFlag = checkAgeRangeValidations(ageArray);
    const newState = filterCategoryData;
    if(!validationFlag){
      newState[index].filters = filterCategoryData[index]?.filters?.map(
        (filter) => {
          if (filter.categoryKey === "age") {
            filter.selectedValue = ageArray;
          }
          return filter;
        }
      );
      setFilterCategoryData([...newState]);
    }else{
      setFilterCategoryData([...newState]);
    }
    if(!validationFlag){
      setDropdownOpenState((prevState) => 
        prevState.map((item, i) => (i === index ? false : false)));
    }

  };


  const [form] = Form.useForm();
  const onReset = (index) => {
    const updatedAgeGroups = [...ageGroups];

    // Reset the selected property of the items in the specified index
    updatedAgeGroups[index] = updatedAgeGroups[index].map((item) => ({
      ...item,
      selected: false,
    }));

    // Ensure the array has at least 5 elements
    while (updatedAgeGroups[index].length < 6) {
      updatedAgeGroups[index].push({
        id: "",
        name: "",
        range: { min: null, max: null },
        selected: false,
      });
    }

    // Slice the array to keep only the first 5 elements
    updatedAgeGroups[index] = updatedAgeGroups[index].slice(0, 6);
    if (updatedAgeGroups[index]?.length > 5) {
      updatedAgeGroups[index][5] = {
        id: "",
        name: "",
        range: { min: null, max: null },
        selected: false,
      };
    }
    setAgeGroups(updatedAgeGroups);
    form.resetFields();
    const formDetails = form.getFieldsValue();
    formDetails[`ageRanges${index}`]?.splice(0, 6);
    form.setFieldsValue(formDetails);
    setAgeValidationMessage("");
  };

  const convertAgeFormat = (ageItem) => {
    return ageItem.length < 1
      ? []
      : ageItem
          .map(
            (group) =>
              `${group.age_label} (${group.age_value[0]} years-${group.age_value[1]} years)`
          )
          .join(", ");
  };

  const addGroup = (index) => {
    setAgeGroups((prevAgeGroups) => 
      prevAgeGroups.map((ageGroup, i) => 
        i === index ? [
          ...ageGroups[index],
          ...[
            {
              id: "",
              name: "",
              range: {
                min: null,
                max: null,
              },
              selected: false,
            },
          ],
        ] : ageGroup
      )
    );
  };

  const removeRow = (index,groupIndex) => {
    const updatedGroups = ageGroups[groupIndex];
    const defaultGroups = [...updatedGroups.slice(0, 5)];
    const remainingGroups = updatedGroups.slice(5, 9);
    remainingGroups.splice(index, 1);
    const formDetails =form.getFieldsValue()
    // setAgeGroups([...defaultGroups, ...remainingGroups]);
    const newAgeGroup = [...defaultGroups, ...remainingGroups];
    setAgeGroups((prevAgeGroups) =>
      prevAgeGroups.map((ageGroup, i) =>
        i === groupIndex ? newAgeGroup : ageGroup
      )
    );

    formDetails[`ageRanges${groupIndex}`].splice(index,1)
    form.setFieldsValue({
      [`ageRanges${groupIndex}`]: formDetails
    });
  };

  const drodownClicked = (index) => {
    setDropdownOpenState((prevState) => 
      prevState.map((item, i) => (i === index ? true : false)));
    setAgeValidationMessage("");    
  };

  const closeDropdown = (index)=>{
    setDropdownOpenState((prevState) => 
      prevState.map((item, i) => (i === index ? false : false)));
  }

  const formValueChanged = (e) => {
    setAgeValidationMessage("");
  };

  return (
    <>
      <Drawer
        title="Define Target Population"
        placement="right"
        onClose={onClose}
        maskClosable={checkCardLimitRunning?false:true}
        // zIndex={0}
        // 
        // rootStyle={isOpen ? { marginTop: 57, right: "26.7vw" } : {}}
        rootStyle={isOpen && !minimizedOpenedReport ? { marginTop: 57, right: "26.7vw" } : {}}

        open={open}
        width={"auto"}
        extra={
          !checkCardLimitRunning && 
          <Space>
            <CloseOutlined onClick={onClose} />
          </Space>
        }
        footer={
         
          <Row justify="" gutter={16}>
            <Col>
              <Button
                type="primary"
                onClick={saveFilterDataHandler}
                disabled={
                  (filterCategoryData.length &&
                    filterCategoryData.some(
                      (category) => !category.comparatorName
                    )) ||
                  !editAccessFlag || checkCardLimitRunning
                }>
                Apply
              </Button>
            </Col>
            <Col>
              <Button disabled={!editAccessFlag || checkCardLimitRunning} onClick={showConfirm}>
                Reset
              </Button>
            </Col>
          </Row>
        }>
        <Row>
          <Col span={24}>
            {checkComparatorName && (
              <Text type="danger">Respondent description must be unique.</Text>
            )}
          </Col>
        </Row>

        <div
          style={{
            width: "100%",
            display: "flex",
            position: "relative",
            justifyContent: "space-between",
            overflowY: "auto", // Allow vertical scrolling if needed
            // maxHeight: "100%",
          }}>
          {/* <Row> */}
          {filterCategoryData.length > 2 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                position: "absolute",
                top: 0,
                left: 244,
                width: filterCategoryData.length === 5 ? "78%" : "58.5%",
                // marginLeft:-10
              }}>
              <LeftOutlined
                onClick={scrollLeft}
                className="custom-icon-left-outlined"
              />
              <RightOutlined
                onClick={scrollRight}
                className="custom-icon-right-outlined"
              />
            </div>
          ) : null}
          <Col
            style={{
              width: 230,
              height: "100%"
            }}
          >
            {filterCategoryData.slice(0,1)?.map((comparator, index) => {
              return (
                <React.Fragment key={index}>
                   {/* this col contains heading of each row */}
                  <Col key={comparator.key}>
                    <Row gutter={[16, 16]} style={{ width: 240 }}>
                      <Col
                        span={24}
                        className="gutter-row"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          gap: "0.5rem",
                        }}>
                        <Row>
                          <Col
                            style={{
                              marginTop: 10,
                              width: "100%",
                              height: 42
                            }}>
                              <strong>Target Population Description</strong>
                          </Col>
                        </Row>
                      </Col>
                      {comparator?.filters?.map((category) => {
                        return (
                          <Col
                            span={category.span}
                            className="gutter-row"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              gap: "0.5rem",
                            }}>
                            <span style={{  height: category.type === "dropdown" ? 48 : 40 }}> 
                              <strong>{category.categoryLabel}</strong>
                              {category.isInfoIcon && (
                                <Tooltip title={category.infoMessage}>
                                  <img
                                    width={15}
                                    src={InfoIcon}
                                    alt={"info"}
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: 5,
                                      verticalAlign: "middle",
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </span>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                  {filterCategoryData?.length != index + 1 && (
                    <Divider
                      type="vertical"
                      className="divider-vertical-drawer"
                    />
                  )}
                </React.Fragment>
              );
            })}
          </Col>
          {/* this divider contains all dropdowns etc */}
          <Divider type="vertical" style={{ height: "auto" }} />
          <div
            ref={containerRef}
            style={{
              width: "100%",
              maxWidth: "35vw",
              padding: "0px 10px",
              overflowX: "auto",
              display: "flex",
              position: "relative",
              opacity: checkCardLimitRunning ? 0.5 : 1,
              pointerEvents: checkCardLimitRunning ? "none" : "auto", // disable click

            }}>
            {filterCategoryData?.map((comparator, index) => {
             
              
              return (

                <React.Fragment key={index}>
                  {/* hi{index}{exploreFilterApplyData[Number(comparator.key)]?.comparator_id} */}
                  {comparatorIdHandler(exploreFilterApplyData[Number(comparator.key)]?.comparator_id , Number(comparator.key) )}
                  <Col key={comparator.key}>

                    <Row gutter={[16, 16]} style={{ width: 264 }}>
                      <Col
                        span={24}
                        className="gutter-row"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          gap: "0.5rem",
                        }}>
                        <Row>
                          {/* {filterCategoryData.length > 1 && (
                            <strong>{index + 1}.</strong>
                          )}
                          <strong>Target Population Description</strong> */}
                          <Col
                            style={{
                              marginTop: 10,
                              width:
                                filterCategoryData.length > 1 ? "80%" : "100%",
                            }}>
                            <Input
                              maxLength={50}
                              placeholder="Add Name"
                              disabled={!editAccessFlag 
                                // || checkCardLimitRunning 
                              }
                              value={comparator.comparatorName}
                              onChange={(event) =>
                                comparatorRenameHandler(event, index)
                              }
                            />
                          </Col>
                          {filterCategoryData.length > 1 && (
                            <Col style={{ marginTop: 12 }}>
                              <img
                                style={{ marginLeft: 8, cursor: "pointer" }}
                                alt={"Delete"}
                                src={DeleteIcon}
                                onClick={() =>
                                  deleteCriteria(
                                    index,
                                    comparator.comparatorName
                                  )
                                }
                              />
                            </Col>
                          )}
                        </Row>
                      </Col>
                      {comparator?.filters?.map((category) => {
                        return category.type === "dropdown" ? (
                          <Col
                            span={category.span}
                            className="gutter-row"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              gap: "0.5rem",
                            }}>
                            <span>
                              {/* <strong>{category.categoryLabel}</strong> */}
                              {/* {category.isInfoIcon && (
                                <Tooltip title={category.infoMessage}>
                                  <img
                                    width={15}
                                    src={InfoIcon}
                                    alt={"info"}
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: 5,
                                      verticalAlign: "middle",
                                    }}
                                  />
                                </Tooltip>
                              )} */}
                            </span>
                            <Select
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                              {...selectProps}
                              onDropdownVisibleChange={(event) =>
                                dropdownToggleHandler(event, category, index)
                              }
                              onChange={(event) =>
                                dropdownChangeHandler(event, category, index)
                              }
                              options={category.options}
                              value={radioValue[index]!="All" && category.categoryKey=="region"?[]:category.selectedValue}
                              loading={category.loading}
                              disabled={
                                // checkDisabled(category.categoryKey, index)
                                // checkCardLimitRunning || 
                                (
                                  radioValue[index]!="All"
                                  // category.selectedValue
                                   && category.categoryKey=="region") || (
                                category.categoryKey === "stage" &&
                                !stageDisabledFlag[index]
                                  ? true
                                  : false
                                )
                              }
                            />
                          </Col>
                        ) : category.type === "single-select-dropdown" ? (
                          <Col
                            span={category.span}
                            className="gutter-row"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              gap: "0.5rem",
                            }}>
                            <span></span>
                            <Select
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                              {...singleSelectProps}
                              showSearch
                              filterOption={(input, option) => {
                                const labelMatch = option.label
                                  .toLowerCase()
                                  .includes(input.toLowerCase());
                                const quesIdMatch = option.ques_id
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase());
                                return labelMatch || quesIdMatch;
                              }}
                              onDropdownVisibleChange={(event) =>
                                dropdownToggleHandler(event, category, index)
                              }
                              onChange={(event) =>
                                dropdownChangeHandler(event, category, index)
                              }
                              options={category.options}
                              value={category.selectedValue}
                              loading={category.loading}
                              disabled={
                                // checkCardLimitRunning || 
                                category.categoryKey === "question_id" &&
                                questionCategoryFlag?.length < 1
                                  ? true
                                  : false
                              }
                            />
                          </Col>
                        ) : category.type === "radio" ? (
                          <Col
                            span={category.span}
                            className="gutter-row"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              minWidth: "100%",
                              gap: "0.5rem",
                              height:'24px',
                              marginTop:'12px'
                            }}>
                           
                            <Radio.Group
                              value={category.selectedValue}
                                onChange={(e) => radioChangeHandler(e, category, index, comparator)}
                              disabled={
                                category.loading || 
                                (category.categoryKey === "stage" && !stageDisabledFlag[index])
                              }
                              style={{
                                display: "flex",
                                flexDirection: "row", // Always horizontal
                                gap: "1rem",
                                justifyContent:'space-around',
                                // flexWrap: "wrap", // Wrap to next line if needed
                                alignItems: "center",
                              }}
                            >
                              {category.options.map((option) => (
                                <Radio 
                                  key={option.value} 
                                  value={option.value}
                                  style={{
                                    margin: "0", // Remove default margins
                                    whiteSpace: "nowrap", // Prevent text wrapping
                                  }}
                                >
                                  {option.label}
                                </Radio>
                              ))}
                            </Radio.Group>
                            
                            {/* Loading indicator for radio (if needed) */}
                          
                          </Col>
                        ):category.type === "custom-label" ? (
                          <Col
                            span={category.span}
                            className="gutter-row"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              gap: "0.5rem",
                            }}>
                            <span></span>
                            <div style={{ height: 26 }}></div>
                          </Col>
                        ) : category.type === "tree" ? (
                          <Col
                            span={category.span}
                            className="gutter-row"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              gap: "0.5rem",
                            }}>
                            {/* <strong>{category.categoryLabel}</strong> */}
                            <TreeSelect
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                              {...tProps}
                              onDropdownVisibleChange={(event) =>
                                dropdownToggleHandler(event, category, index)
                              }
                              onChange={(event) =>
                                dropdownChangeHandler(
                                  event,
                                  category,
                                  index,
                                  comparator.comparatorName
                                )
                              }
                              // treeData={
                              //   !editAccessFlag
                              //     ? treeDataWithDisabled(category.options)
                              //     : category.options
                              // }
                              treeData={category.categoryKey === "geo_state"?(
                                !editAccessFlag
                                  ? treeDataWithDisabled(duplicateSharedChild(category.options,"Unspecified"))
                                  : duplicateSharedChild(category.options,"Unspecified")
                              ):(
                                 !editAccessFlag
                                  ? treeDataWithDisabled(category.options)
                                  : category.options
                              )}
                              value={category.selectedValue}
                              loading={category.loading}
                              disabled={
                                (category.categoryKey === "lov_id" &&
                                questionResponseFlag?.length < 1
                                  ? true
                                  : false) ||
                                (category.categoryKey === "other_indication" &&
                                otherIndicationFlag[index]
                                  ? true
                                  : false)
                              }
                              showSearch
                             
                              //  filterTreeNode={(inputValue, treeNode) =>                                
                              //   treeNode?.title
                              //     ?.toLowerCase()
                              //     ?.includes(inputValue?.toLowerCase())
                              // }
                              filterTreeNode={(inputValue, treeNode) => {
                                const normalize = (str) =>
                                  (str || "")
                                    .toString()
                                    .normalize("NFD")
                                    .replace(/[\u0300-\u036f]/g, "")
                                    .toLowerCase();

                                return normalize(treeNode?.title).includes(normalize(inputValue));
                              }}

                            />
                          </Col>
                        ) : category.type === "survey-year-tree" ? (
                          <Col
                            span={category.span}
                            className="gutter-row"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              gap: "0.5rem",
                            }}>
                            {/* <strong>{category.categoryLabel}</strong> */}
                            <TreeSelect
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                              {...tPropsSurveyYear}
                              onDropdownVisibleChange={(event) =>
                                dropdownToggleHandler(event, category, index)
                              }
                              onChange={(event) =>
                                dropdownChangeHandler(
                                  event,
                                  category,
                                  index,
                                  comparator.comparatorName
                                )
                              }
                              treeData={
                                !editAccessFlag
                                  ? treeDataWithDisabled(category.options)
                                  : category.options
                              }
                              value={category.selectedValue}
                              loading={category.loading}
                            />
                          </Col>
                        ) : category.type === "dropdown-custom" ? (
                          <Col
                            span={category.span}
                            className="gutter-row"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              gap: "0.5rem",
                            }}>
                            {/* <strong>{category.categoryLabel}</strong> */}
                            <Select
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                              // disabled={checkCardLimitRunning}
                              ref={selectRef}
                              {...selectProps}
                              open={dropdownOpenState[index]}
                              onDropdownVisibleChange={(event) =>
                                dropdownToggleHandler(event, category, index)
                              }
                              // onBlur={() => dropdownToggleHandler(false, category, index)}

                              onChange={(event) =>
                                dropdownChangeHandler(event, category, index)
                              }
                              onClick={() => drodownClicked(index)}
                              options={category.options}
                              value={convertAgeFormat(category.selectedValue)}
                              loading={category.loading}
                              className="age-dropdown"
                              placeholder="All"
                              dropdownStyle={{ width: 270, minWidth: 270 }}
                              dropdownRender={(menu) => (
                                <div style={{ padding: 10 }}>
                                  {/* <div><CloseOutlined onClick={()=>closeDropdown(index)} /></div> */}
                                  <Row
                                    style={{
                                      fontWeight: "bold",
                                      marginBottom: "10px",
                                    }}>
                                    <Col style={{ paddingLeft: 7 }} span={12}>
                                      Age Group
                                    </Col>
                                    <Col span={12}>Range in Years</Col>
                                  </Row>
                                  {ageGroups[index]
                                    ?.slice(0, 5)
                                    .map((group) => (
                                      <>
                                        <Row
                                          key={group.id}
                                          style={{
                                            marginBottom: "10px",
                                            alignItems: "center",
                                          }}>
                                        <Col style={{ paddingLeft: 7 }} span={12}>
                                            <Checkbox
                                              checked={group.selected}
                                              onChange={() => handleCheckboxChange(group.id, index)}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  maxWidth: 90,          // tune: checkbox ~16px + padding, so ~90px left for text
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  verticalAlign: "middle",
                                                }}
                                                title={group.name}      // full name on hover
                                              >
                                                {group.name}
                                              </span>
                                            </Checkbox>
                                          </Col>
                                          <Col span={12}>
                                            {group.range.min !== null &&
                                            group.range.max !== null ? (
                                              `(${group.range.min} - ${group.range.max} years)`
                                            ) : (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}></div>
                                            )}
                                          </Col>
                                        </Row>
                                      </>
                                    ))}

                                  <Col>
                                    <Form
                                      form={form}
                                      name={`dynamic_form_nest_item_${index}`}
                                      onFinish={(values) =>
                                        onFinish(values, index)
                                      }
                                      onValuesChange={formValueChanged}
                                      clearOnDestroy={true}
                                      style={{
                                        maxWidth: 600,
                                      }}
                                      autoComplete="off">
                                      <Form.List name={`ageRanges${index}`}>
                                        {(fields, { add, remove }) => (
                                          <>
                                            {ageGroups[index]
                                              ?.slice(5, 9)
                                              .map((group, i) => (
                                                <Space
                                                  key={i}
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}>
                                                  <Form.Item
                                                    name={[i, "checked"]}
                                                    valuePropName="checked"
                                                    initialValue={
                                                      group.selected
                                                    }>
                                                    <Checkbox />
                                                  </Form.Item>
                                                  <Form.Item
                                                    name={[i, "name"]}
                                                    initialValue={group.name}>
                                                    <Input placeholder="Age Group Name" />
                                                  </Form.Item>
                                                  <Form.Item
                                                    name={[i, "minAge"]}
                                                    initialValue={
                                                      group.range.min
                                                    }>
                                                    <InputNumber
                                                      min={1}
                                                      style={{ width: 60 }}
                                                      max={120}
                                                      placeholder="Min Age"
                                                    />
                                                  </Form.Item>
                                                  <Form.Item
                                                    name={[i, "maxAge"]}
                                                    initialValue={
                                                      group.range.max
                                                    }>
                                                    <InputNumber
                                                      min={1}
                                                      style={{ width: 60 }}
                                                      max={120}
                                                      placeholder="Max Age"
                                                    />
                                                  </Form.Item>
                                                  <Form.Item style={{}}>
                                                    <DeleteOutlined
                                                      onClick={() =>
                                                        removeRow(i, index)
                                                      }
                                                    />
                                                  </Form.Item>
                                                </Space>
                                              ))}
                                            <Form.Item
                                              style={{ marginBottom: 0 }}>
                                              <Button
                                                type="text"
                                                onClick={() => addGroup(index)}
                                                block
                                                icon={<PlusOutlined />}
                                                style={{
                                                  textAlign: "left",
                                                  paddingTop: 10,
                                                }}
                                                disabled={
                                                  ageGroups[index]?.length >= 9
                                                }>
                                                Add New Age Group
                                              </Button>
                                            </Form.Item>
                                          </>
                                        )}
                                      </Form.List>
                                      <Form.Item style={{ marginBottom: 0 }}>
                                        {ageValidationMessage && (
                                          <div>
                                            <br />
                                            <Text type="danger">
                                              {ageValidationMessage}
                                            </Text>
                                            <br />
                                          </div>
                                        )}
                                        <br />
                                        <Button
                                          disabled={
                                            ageValidationMessage.length > 0
                                          }
                                          type="primary"
                                          htmlType="submit"
                                          onClick={() =>
                                            onFinish(
                                              form.getFieldsValue(),
                                              index
                                            )
                                          }>
                                          Apply
                                        </Button>
                                        <Button
                                          type="text"
                                          onClick={() => onReset(index)}>
                                          Reset
                                        </Button>
                                      </Form.Item>
                                    </Form>
                                  </Col>
                                </div>
                              )}
                            />
                          </Col>
                        ) : (
                          <></>
                        );
                      })}
                    </Row>
                  </Col>
                  {filterCategoryData?.length != index + 1 && (
                    <Divider
                      type="vertical"
                      className="divider-vertical-drawer"
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>
          <Divider type="vertical" style={{ height: "auto" }} />
          {editAccessFlag && filterCategoryData?.length < 5 && (
          <Col
            style={{
              width: 120,
              border: "1px solid #62D2D1",
              background: checkCardLimitRunning ? "#e0e0e0" : "#F3FCFE", // gray out if disabled
              cursor: checkCardLimitRunning ? "not-allowed" : "pointer",
              opacity: checkCardLimitRunning ? 0.6 : 1,
              // pointerEvents: checkCardLimitRunning ? "none" : "auto", // disable click
            }}
            onClick={() => {
              if (!checkCardLimitRunning) addComparator(); // fallback in case pointerEvents fails
            }}
          >
            <div style={{ textAlign: "center", marginTop: "10%" }}>
              <img alt={"Plus Icon"} src={PlusIcon} />
              <div
                style={{
                  color: checkCardLimitRunning ? "#999" : "#2D8B93",
                }}
              >
                Add Comparator Population
              </div>
            </div>
          </Col>
        )}

          {/* </Row> */}
        </div>
      </Drawer>
    </>
  );
};
export default RespondentFilter;
